import axios from '@/app/axios'
import CrudService from '@/common/services/crud-service'
import Tenant from '@/tenants/entities/tenant'
import Responses from '@/app/utils/responses'

class TenantsService extends CrudService<Tenant> {
  public async loadAllAsync() {
    const res = await axios.get<Tenant[]>(`${this.resource}/all`)
    return Responses.list(res)
  }
}

export default new TenantsService('tenants')
